"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Chip.default;
  }
});

var _Chip = _interopRequireDefault(require("./Chip"));


/*****************
 ** WEBPACK FOOTER
 ** ./~/@material-ui/core/Chip/index.js
 ** module id = 653
 ** module chunks = 0
 **/